import ConfirmCVVModal from 'components/GlobalModals/ConfirmCVVModal/ConfirmCVVModal';
import withGlobalModals from 'hocs/withGlobalModals';
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import OrderActions from 'actions/OrderActions';
import Actions from 'Actions';
import UtilActions from 'utils/redux/Actions';
import CheckoutApi from 'services/api/checkout';
import { orderSelector } from 'selectors/order/orderSelector';
import { swapPaypalToCreditCard } from 'services/Checkout';
import historyLocationActions from 'actions/framework/HistoryLocationActions';
import ConfirmCVVModalEN from 'components/GlobalModals/ConfirmCVVModal/locales/ConfirmCVVModal_en_US';
import ConfirmCVVModalFR from 'components/GlobalModals/ConfirmCVVModal/locales/ConfirmCVVModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(ConfirmCVVModalEN, ConfirmCVVModalFR);

const fields = createSelector(
    orderDetailsSelector,
    orderSelector,
    createStructuredSelector({
        title: getTextFromResource(getText, 'title'),
        confirmSecurityCode: getTextFromResource(getText, 'confirmSecurityCode'),
        securityCodeLabel: getTextFromResource(getText, 'securityCodeLabel'),
        changePaymentMethod: getTextFromResource(getText, 'changePaymentMethod'),
        confirmPlaceOrder: getTextFromResource(getText, 'confirmPlaceOrder')
    }),
    (orderDetails, order, localization) => {
        const storeDetails = orderDetails?.pickup?.storeDetails;
        const orderId = orderDetails?.header?.orderId;

        return {
            addAlternatePickupPerson: CheckoutApi.addAlternatePickupPerson,
            updateAlternatePickupPerson: CheckoutApi.updateAlternatePickupPerson,
            removeAlternatePickupPerson: CheckoutApi.removeAlternatePickupPerson,
            localization,
            storeDetails,
            orderId,
            pendingCreditCard: order.pendingCreditCard
        };
    }
);

const functions = {
    updateSDUTerms: OrderActions.updateSDUTerms,
    showConfirmCVVModal: Actions.showConfirmCVVModal,
    goToURL: historyLocationActions.goTo,
    orderMerge: UtilActions.merge,
    swapPaypalToCreditCard,
    clearPendingCreditCard: OrderActions.clearPendingCreditCard
};

const withConfirmCVVModalProps = wrapHOC(connect(fields, functions));

export default withGlobalModals(withConfirmCVVModalProps(ConfirmCVVModal));
